import React from 'react'
import Main from '../../cpn/Main'
import {Divider, Row} from 'antd'
import LedgerTableDept from './LedgerTableDept'
import LedgerTableClient from './LedgerTableClient'
import LedgerTableClientType from './LedgerTableClientType'
import LedgerTableGoods from './LedgerTableGoods'
import LedgerTableGoodsType from './LedgerTableGoodsType'
import LedgerTableOperator from './LedgerTableOperator'
import LedgerTableSalesman from './LedgerTableSalesman'
import LedgerTableArapDept from './LedgerTableArapDept'
import LedgerTableArapClient from './LedgerTableArapClient'
import LedgerTableArapStatement from './LedgerTableArapStatement'
//
import ArapTableDept from './ArapTableDept'
import ArapTableClient from './ArapTableClient'
import ArapTableClientType from './ArapTableClientType'
import ArapTableGoods from './ArapTableGoods'
import ArapTableGoodsType from './ArapTableGoodsType'
import ArapTableOperator from './ArapTableOperator'
import ArapTableSalesman from './ArapTableSalesman'
//
import FundTableDept from './FundTableDept';
import FundTableClient from './FundTableClient';
import FundTableClientType from './FundTableClientType';
import FundTableGoods from './FundTableGoods';
import FundTableGoodsType from './FundTableGoodsType';
import FundTableOperator from './FundTableOperator';
import FundTableSalesman from '../statForm/FundTableSalesman';
function StatForm() {    
    return (
        <Main  t1='统计报表'>
            <Divider>团队台账报表</Divider>
            <Row>                
                <LedgerTableDept />        
                <LedgerTableClient />            
                <LedgerTableClientType />            
                <LedgerTableGoods />                     
                <LedgerTableGoodsType />                              
                <LedgerTableOperator />                              
                <LedgerTableSalesman />                              
                <LedgerTableArapDept />                              
                <LedgerTableArapClient />                              
                <LedgerTableArapStatement />                                       
            </Row>
            <Divider>团队台账+费用+已下账报表</Divider>
            <Row>                                
                <ArapTableDept />      
                <ArapTableClient />            
                <ArapTableClientType />            
                <ArapTableGoods  />            
                <ArapTableGoodsType />            
                <ArapTableOperator />            
                <ArapTableSalesman />            
            </Row>
            <Divider>团队台账+费用+已转账报表</Divider>
            <Row>                                
                <FundTableDept />
                <FundTableClient />
                <FundTableClientType />
                <FundTableGoods />
                <FundTableGoodsType />
                <FundTableOperator />
                <FundTableSalesman />          
            </Row>
        </Main>
    )
}

export default StatForm